import { render, staticRenderFns } from "./wx-link-btn.vue?vue&type=template&id=1b8a4496&"
import script from "./wx-link-btn.vue?vue&type=script&lang=js&"
export * from "./wx-link-btn.vue?vue&type=script&lang=js&"
import style0 from "./wx-link-btn.vue?vue&type=style&index=0&id=1b8a4496&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.2.47_css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10._wyjk5suo23ynklbyyfuevipziy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports